
import { defineComponent, ref } from 'vue';
import { shrimp } from './assets/shrimp';
import MarkeredBackground from './MarkeredBackground.vue';
import MarkeredPath from './MarkeredPath.vue';
import AnimationToggle from './AnimationToggle.vue';

export default defineComponent({
  name: 'LostInParadise',
  components: {
    MarkeredBackground,
    MarkeredPath,
    AnimationToggle
  },

  setup() {
    const animationToggle = ref<boolean>();

    return {
      path: shrimp,
      animationToggle
    };
  }
});
